module.exports = __webpack_public_path__ + "img/3.271e298c.png";